exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-mask-wrap[data-v-355a10da]{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.1);z-index:1071}", ""]);

// exports
